import React, { useState, useEffect } from 'react';
import { Result, Button, Divider } from 'antd';
import TextEvents from 'app/components/TextEvents';
import RadioGroup from 'app/components/RadioGroup/RadioGroup'
import Grid from '@material-ui/core/Grid';
import isEmpty from 'app/utils/IsEmpty';


export default function QuizForm(props) {
    const [finalAnswers, setFinalAnswers] = useState([]);


    useEffect(() => {
        if (isEmpty(finalAnswers)) {
            setFinalAnswers(props.quizData.questions);
        }
    })

    const onChangeWhenIsWorkCycle = (e, question) => {

        const answerObj = {
            idQuestion: question.idQuestion,
            idAnswer: e.target.value,
            comment: ''
        };

        finalAnswers[finalAnswers.indexOf(question)]['isAnswered'] = true;
        finalAnswers[finalAnswers.indexOf(question)]['correctListAnswers'] = [];
        finalAnswers[finalAnswers.indexOf(question)]['correctListAnswers'].push(answerObj);
        props.setQuizQuestionsData(finalAnswers);
        let answeredAll = true
        if (props.quizQuestionsData !== undefined) {
            props.quizQuestionsData.forEach(qd => {
                if (qd.correctListAnswers === undefined)
                    answeredAll = false

            })
        } else { answeredAll = false }
        props.setFinish(answeredAll)

    }

    const createQuestionsAndAnswers = (data) => {

        return(
            <>
                <Grid container spacing={0} item xs={12} sm={12} md={12}>
                    {
                        data.map((x) => (
                            <>
                                <Grid item xs={12} sm={6} md={8} key={'question' + x.idQuestion}>
                                    <TextEvents
                                        text={x.questionDescription}
                                        color="cotemar"
                                        size='subtitle'
                                        weight="bold"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} key={'questionR' + x.idQuestion}>                                    
                                    <RadioGroup
                                        copyQuestion={x}
                                        question={x}
                                        onChange={onChangeWhenIsWorkCycle}
                                        value={Array.isArray(x.correctAnswer) ? x.correctAnswer[0] :
                                            Array.isArray(x.correctListAnswers) ? x.correctListAnswers[0].idAnswer : null}
                                        listAnswers={x.listAnswers}
                                    />
                                </Grid>
                                <Divider key={'divider' + x.idQuestion} />
                            </>
                        ))
                    }
                </Grid>
            </>
        )
    }

    return Object.keys(props.quizData).length > 0 ?
        <div>
            {props.quizData.questions.length !== 0 ?
                <div className={props.classes.stepsContent}>

                    <div >
                        <Grid container
                            direction="column"
                            justify="center"
                            alignItems="flex-start"
                            className={props.classes.answersContainer}
                        >
                            {typeof finalAnswers !== 'undefined' ? createQuestionsAndAnswers(finalAnswers) : ''}
                        </Grid>
                    </div>
                </div> :
                <Result
                    status="warning"
                    title="Ocurrió un problema con la operación, intente más tarde."
                    extra={
                        <Button type="primary" key="console" onClick={() => props.setChildrenVisible(false)}>
                            Regresar
                        </Button>
                    }
                />
            }
        </div> : <div />;

}